const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiputan6New(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225px",
    height: "225px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe5f04",
    d: "M -0.5,-0.5 C 15.5,-0.5 31.5,-0.5 47.5,-0.5C 47.7842,47.5178 47.7842,95.5178 47.5,143.5C 44.8333,143.5 42.1667,143.5 39.5,143.5C 39.5,146.167 39.5,148.833 39.5,151.5C 42.1667,151.5 44.8333,151.5 47.5,151.5C 47.5,175.833 47.5,200.167 47.5,224.5C 31.5,224.5 15.5,224.5 -0.5,224.5C -0.5,149.5 -0.5,74.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd5a02",
    d: "M 47.5,-0.5 C 55.5,-0.5 63.5,-0.5 71.5,-0.5C 71.5,26.1667 71.5,52.8333 71.5,79.5C 73.6361,79.5379 74.9694,80.2046 75.5,81.5C 74.4886,83.3716 73.6552,85.3716 73,87.5C 72.3333,88.8333 71.6667,88.8333 71,87.5C 69.8644,90.0964 69.031,92.763 68.5,95.5C 67.8333,97.1667 67.1667,98.8333 66.5,100.5C 61.9765,102.635 59.9765,106.302 60.5,111.5C 59.8423,112.398 59.1757,113.398 58.5,114.5C 57.3343,125.151 57.1676,135.818 58,146.5C 59.0386,147.244 59.5386,148.244 59.5,149.5C 59.3433,150.873 59.51,152.207 60,153.5C 61.4618,155.437 62.6285,157.437 63.5,159.5C 65.0301,160.211 66.3634,161.211 67.5,162.5C 67.3284,163.492 67.6618,164.158 68.5,164.5C 67.9162,167.285 68.9162,168.952 71.5,169.5C 73.9024,171.909 76.5691,173.909 79.5,175.5C 79.5,176.167 79.5,176.833 79.5,177.5C 78.1266,177.657 76.7932,177.49 75.5,177C 74.8534,175.391 74.02,173.891 73,172.5C 71.9916,172.982 70.825,173.148 69.5,173C 70,173.5 70.5,174 71,174.5C 71.4999,191.163 71.6666,207.83 71.5,224.5C 63.5,224.5 55.5,224.5 47.5,224.5C 47.5,200.167 47.5,175.833 47.5,151.5C 44.8333,151.5 42.1667,151.5 39.5,151.5C 39.5,148.833 39.5,146.167 39.5,143.5C 42.1667,143.5 44.8333,143.5 47.5,143.5C 47.7842,95.5178 47.7842,47.5178 47.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd5302",
    d: "M 71.5,-0.5 C 84.8333,-0.5 98.1667,-0.5 111.5,-0.5C 111.5,10.1667 111.5,20.8333 111.5,31.5C 109.462,34.5692 107.795,37.9025 106.5,41.5C 106.5,42.1667 106.5,42.8333 106.5,43.5C 104.738,44.2623 103.738,45.5956 103.5,47.5C 102.094,47.9731 101.427,48.9731 101.5,50.5C 97.609,54.0623 94.9424,58.3957 93.5,63.5C 92.325,63.281 91.325,63.6143 90.5,64.5C 90.0576,65.7387 89.3909,66.7387 88.5,67.5C 87.1779,67.33 86.0113,67.6634 85,68.5C 83.298,72.3298 81.4646,75.9964 79.5,79.5C 78.1667,80.1667 76.8333,80.8333 75.5,81.5C 74.9694,80.2046 73.6361,79.5379 71.5,79.5C 71.5,52.8333 71.5,26.1667 71.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe4702",
    d: "M 111.5,-0.5 C 124.833,-0.5 138.167,-0.5 151.5,-0.5C 151.5,10.1667 151.5,20.8333 151.5,31.5C 153.735,31.2053 155.735,31.5386 157.5,32.5C 141.991,32.8295 126.658,32.4962 111.5,31.5C 111.5,20.8333 111.5,10.1667 111.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe4101",
    d: "M 151.5,-0.5 C 156.167,-0.5 160.833,-0.5 165.5,-0.5C 164.902,27.5599 165.568,55.5599 167.5,83.5C 166.189,87.4068 165.522,91.4068 165.5,95.5C 163.339,95.5094 162.006,96.1761 161.5,97.5C 160.446,97.3201 159.446,96.9867 158.5,96.5C 158.758,94.2419 158.758,91.9085 158.5,89.5C 156.833,89.5 155.167,89.5 153.5,89.5C 152.636,87.8035 151.303,86.6368 149.5,86C 151.941,85.964 153.941,85.1307 155.5,83.5C 154.68,81.8888 153.346,81.2222 151.5,81.5C 151.334,75.4908 151.501,69.4908 152,63.5C 153.167,62.3333 154.333,61.1667 155.5,60C 155.167,59.6667 154.833,59.3333 154.5,59C 155.509,56.8282 157.176,55.6615 159.5,55.5C 159.762,54.0222 159.429,52.6888 158.5,51.5C 156.177,52.6716 153.844,52.6716 151.5,51.5C 151.322,50.3052 150.989,49.1385 150.5,48C 151.628,45.545 153.128,43.3784 155,41.5C 155.49,40.2068 155.657,38.8734 155.5,37.5C 155.833,37.5 156.167,37.5 156.5,37.5C 157.5,37.5 158.5,37.5 159.5,37.5C 159.923,35.2188 159.256,33.5521 157.5,32.5C 155.735,31.5386 153.735,31.2053 151.5,31.5C 151.5,20.8333 151.5,10.1667 151.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe3a03",
    d: "M 165.5,-0.5 C 185.167,-0.5 204.833,-0.5 224.5,-0.5C 224.5,74.5 224.5,149.5 224.5,224.5C 204.833,224.5 185.167,224.5 165.5,224.5C 165,212.086 165.667,199.753 167.5,187.5C 166.833,184.833 166.167,182.167 165.5,179.5C 167.154,172.934 167.821,166.267 167.5,159.5C 172.629,159.281 172.629,158.614 167.5,157.5C 166.981,152.909 166.981,148.242 167.5,143.5C 168.827,139.217 169.493,134.551 169.5,129.5C 169.333,124.833 169.167,120.167 169,115.5C 167.25,113.743 166.084,111.743 165.5,109.5C 165.84,106.856 165.173,104.523 163.5,102.5C 166.068,102.048 167.401,100.548 167.5,98C 167.316,96.6244 166.649,95.7911 165.5,95.5C 165.522,91.4068 166.189,87.4068 167.5,83.5C 165.568,55.5599 164.902,27.5599 165.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e04811",
    d: "M 111.5,31.5 C 126.658,32.4962 141.991,32.8295 157.5,32.5C 159.256,33.5521 159.923,35.2188 159.5,37.5C 158.5,37.5 157.5,37.5 156.5,37.5C 156.5,36.1667 156.5,34.8333 156.5,33.5C 141.324,33.1706 126.324,33.5039 111.5,34.5C 111.5,35.1667 111.5,35.8333 111.5,36.5C 110.094,36.9731 109.427,37.9731 109.5,39.5C 108.5,40.1667 107.5,40.8333 106.5,41.5C 107.795,37.9025 109.462,34.5692 111.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d87750",
    d: "M 111.5,34.5 C 126.324,33.5039 141.324,33.1706 156.5,33.5C 156.5,34.8333 156.5,36.1667 156.5,37.5C 156.167,37.5 155.833,37.5 155.5,37.5C 155.5,36.5 155.5,35.5 155.5,34.5C 140.833,34.5 126.167,34.5 111.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eca483",
    d: "M 111.5,36.5 C 111.573,38.0269 110.906,39.0269 109.5,39.5C 109.427,37.9731 110.094,36.9731 111.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fce5d0",
    d: "M 111.5,34.5 C 126.167,34.5 140.833,34.5 155.5,34.5C 155.5,35.5 155.5,36.5 155.5,37.5C 154.167,37.5 153.5,38.1667 153.5,39.5C 152.094,39.9731 151.427,40.9731 151.5,42.5C 149.461,43.6718 148.128,45.3384 147.5,47.5C 146.728,48.6935 145.728,49.6935 144.5,50.5C 146.566,45.3292 148.899,40.3292 151.5,35.5C 138.816,35.1676 126.149,35.5009 113.5,36.5C 110.838,41.4772 107.505,45.8105 103.5,49.5C 103.5,48.8333 103.5,48.1667 103.5,47.5C 105.262,46.7377 106.262,45.4044 106.5,43.5C 106.5,42.8333 106.5,42.1667 106.5,41.5C 107.5,40.8333 108.5,40.1667 109.5,39.5C 110.906,39.0269 111.573,38.0269 111.5,36.5C 111.5,35.8333 111.5,35.1667 111.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d48a5d",
    d: "M 153.5,39.5 C 153.573,41.0269 152.906,42.0269 151.5,42.5C 151.427,40.9731 152.094,39.9731 153.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfb",
    d: "M 144.5,50.5 C 144.167,51.1667 143.833,51.8333 143.5,52.5C 143.5,53.5 143.5,54.5 143.5,55.5C 141.821,55.2852 140.821,55.9519 140.5,57.5C 138.631,59.0337 137.298,61.0337 136.5,63.5C 135.662,63.8417 135.328,64.5084 135.5,65.5C 133.086,66.9108 131.419,68.9108 130.5,71.5C 129.11,72.8993 128.11,74.5659 127.5,76.5C 123.69,77.7542 123.69,78.7542 127.5,79.5C 127.842,80.3382 128.508,80.6716 129.5,80.5C 133.359,84.4295 138.026,86.7628 143.5,87.5C 145.514,87.3915 147.18,88.0582 148.5,89.5C 149.789,90.6366 150.789,91.9699 151.5,93.5C 151.973,94.9063 152.973,95.573 154.5,95.5C 155.01,98.6743 156.677,101.008 159.5,102.5C 159.5,103.167 159.833,103.5 160.5,103.5C 160.259,107.019 161.593,109.685 164.5,111.5C 164.674,113.861 165.007,116.194 165.5,118.5C 166.751,126.837 166.751,135.17 165.5,143.5C 164.908,146.127 164.575,148.794 164.5,151.5C 162.787,152.635 162.12,154.302 162.5,156.5C 158.604,161.274 154.937,166.274 151.5,171.5C 148.796,171.67 147.129,173.003 146.5,175.5C 144.821,175.285 143.821,175.952 143.5,177.5C 140.911,177.461 138.911,178.461 137.5,180.5C 136.508,180.328 135.842,180.662 135.5,181.5C 133.62,181.229 132.287,181.896 131.5,183.5C 130.167,183.833 128.833,184.167 127.5,184.5C 119.525,185.276 111.525,185.61 103.5,185.5C 100.145,185.909 97.1445,185.242 94.5,183.5C 93.3646,181.787 91.698,181.12 89.5,181.5C 88.1667,180.833 86.8333,180.167 85.5,179.5C 84.1979,177.178 82.1979,175.845 79.5,175.5C 77.4309,172.427 74.7642,170.094 71.5,168.5C 70.9744,166.77 69.9744,165.436 68.5,164.5C 67.6618,164.158 67.3284,163.492 67.5,162.5C 68.3722,157.562 67.0388,153.395 63.5,150C 59.8637,140.186 58.5304,130.019 59.5,119.5C 63.2505,114.926 65.2505,109.593 65.5,103.5C 67.4628,102.04 69.2962,100.373 71,98.5C 72.6554,94.6969 74.4888,91.0302 76.5,87.5C 77.075,85.5887 78.075,83.922 79.5,82.5C 79.5,81.5 79.5,80.5 79.5,79.5C 80.4959,79.5858 81.3292,79.2524 82,78.5C 83.6572,75.3537 85.4906,72.3537 87.5,69.5C 90.935,68.8084 92.935,66.8084 93.5,63.5C 94.9424,58.3957 97.609,54.0623 101.5,50.5C 102.167,50.1667 102.833,49.8333 103.5,49.5C 107.505,45.8105 110.838,41.4772 113.5,36.5C 126.149,35.5009 138.816,35.1676 151.5,35.5C 148.899,40.3292 146.566,45.3292 144.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecad79",
    d: "M 106.5,43.5 C 106.262,45.4044 105.262,46.7377 103.5,47.5C 103.738,45.5956 104.738,44.2623 106.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec996f",
    d: "M 103.5,47.5 C 103.5,48.1667 103.5,48.8333 103.5,49.5C 102.833,49.8333 102.167,50.1667 101.5,50.5C 101.427,48.9731 102.094,47.9731 103.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da8460",
    d: "M 147.5,47.5 C 147.631,50.3667 146.297,52.0334 143.5,52.5C 143.833,51.8333 144.167,51.1667 144.5,50.5C 145.728,49.6935 146.728,48.6935 147.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f94506",
    d: "M 151.5,51.5 C 153.844,52.6716 156.177,52.6716 158.5,51.5C 159.429,52.6888 159.762,54.0222 159.5,55.5C 157.176,55.6615 155.509,56.8282 154.5,59C 154.833,59.3333 155.167,59.6667 155.5,60C 154.333,61.1667 153.167,62.3333 152,63.5C 151.501,69.4908 151.334,75.4908 151.5,81.5C 153.346,81.2222 154.68,81.8888 155.5,83.5C 153.941,85.1307 151.941,85.964 149.5,86C 151.303,86.6368 152.636,87.8035 153.5,89.5C 155.167,89.5 156.833,89.5 158.5,89.5C 158.758,91.9085 158.758,94.2419 158.5,96.5C 159.446,96.9867 160.446,97.3201 161.5,97.5C 162.006,96.1761 163.339,95.5094 165.5,95.5C 166.649,95.7911 167.316,96.6244 167.5,98C 167.401,100.548 166.068,102.048 163.5,102.5C 165.173,104.523 165.84,106.856 165.5,109.5C 165.167,109.5 164.833,109.5 164.5,109.5C 164.425,106.593 163.591,103.927 162,101.5C 161.329,100.748 160.496,100.414 159.5,100.5C 157.667,98.8883 156,97.2216 154.5,95.5C 154.179,93.9519 153.179,93.2852 151.5,93.5C 150.789,91.9699 149.789,90.6366 148.5,89.5C 147.813,85.6478 145.479,83.9811 141.5,84.5C 139.898,82.9261 137.898,82.2594 135.5,82.5C 134.167,81.8333 132.833,81.1667 131.5,80.5C 130.722,79.8444 130.056,79.0111 129.5,78C 130.987,75.7092 131.987,73.2092 132.5,70.5C 133.167,69.1667 134.167,68.1667 135.5,67.5C 137.744,64.7717 140.244,62.105 143,59.5C 143.49,58.2068 143.657,56.8734 143.5,55.5C 145.25,54.2583 146.917,52.7583 148.5,51C 149.577,50.5304 150.577,50.6971 151.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e14d19",
    d: "M 155.5,37.5 C 155.657,38.8734 155.49,40.2068 155,41.5C 153.128,43.3784 151.628,45.545 150.5,48C 150.989,49.1385 151.322,50.3052 151.5,51.5C 150.577,50.6971 149.577,50.5304 148.5,51C 146.917,52.7583 145.25,54.2583 143.5,55.5C 143.5,54.5 143.5,53.5 143.5,52.5C 146.297,52.0334 147.631,50.3667 147.5,47.5C 148.128,45.3384 149.461,43.6718 151.5,42.5C 152.906,42.0269 153.573,41.0269 153.5,39.5C 153.5,38.1667 154.167,37.5 155.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e04f20",
    d: "M 143.5,55.5 C 143.657,56.8734 143.49,58.2068 143,59.5C 140.244,62.105 137.744,64.7717 135.5,67.5C 135.5,66.8333 135.5,66.1667 135.5,65.5C 135.328,64.5084 135.662,63.8417 136.5,63.5C 138.738,62.1473 140.071,60.1473 140.5,57.5C 140.821,55.9519 141.821,55.2852 143.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eba685",
    d: "M 140.5,57.5 C 140.071,60.1473 138.738,62.1473 136.5,63.5C 137.298,61.0337 138.631,59.0337 140.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcd0b7",
    d: "M 93.5,63.5 C 92.935,66.8084 90.935,68.8084 87.5,69.5C 87.8333,68.8333 88.1667,68.1667 88.5,67.5C 89.3909,66.7387 90.0576,65.7387 90.5,64.5C 91.325,63.6143 92.325,63.281 93.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d96629",
    d: "M 88.5,67.5 C 88.1667,68.1667 87.8333,68.8333 87.5,69.5C 85.4906,72.3537 83.6572,75.3537 82,78.5C 81.3292,79.2524 80.4959,79.5858 79.5,79.5C 81.4646,75.9964 83.298,72.3298 85,68.5C 86.0113,67.6634 87.1779,67.33 88.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec926f",
    d: "M 135.5,65.5 C 135.5,66.1667 135.5,66.8333 135.5,67.5C 134.167,68.1667 133.167,69.1667 132.5,70.5C 131.833,70.8333 131.167,71.1667 130.5,71.5C 131.419,68.9108 133.086,66.9108 135.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da9f87",
    d: "M 127.5,76.5 C 127.5,77.5 127.5,78.5 127.5,79.5C 123.69,78.7542 123.69,77.7542 127.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d85e2a",
    d: "M 132.5,70.5 C 131.987,73.2092 130.987,75.7092 129.5,78C 130.056,79.0111 130.722,79.8444 131.5,80.5C 130.833,80.5 130.167,80.5 129.5,80.5C 128.508,80.6716 127.842,80.3382 127.5,79.5C 127.5,78.5 127.5,77.5 127.5,76.5C 128.11,74.5659 129.11,72.8993 130.5,71.5C 131.167,71.1667 131.833,70.8333 132.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9774b",
    d: "M 135.5,82.5 C 137.898,82.2594 139.898,82.9261 141.5,84.5C 139.102,84.7406 137.102,84.0739 135.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7a372",
    d: "M 79.5,82.5 C 78.075,83.922 77.075,85.5887 76.5,87.5C 76.1667,87.5 75.8333,87.5 75.5,87.5C 75.3692,84.6333 76.7026,82.9666 79.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d65a2a",
    d: "M 141.5,84.5 C 145.479,83.9811 147.813,85.6478 148.5,89.5C 147.18,88.0582 145.514,87.3915 143.5,87.5C 143.218,86.2223 142.551,85.2223 141.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fae4d0",
    d: "M 129.5,80.5 C 130.167,80.5 130.833,80.5 131.5,80.5C 132.833,81.1667 134.167,81.8333 135.5,82.5C 137.102,84.0739 139.102,84.7406 141.5,84.5C 142.551,85.2223 143.218,86.2223 143.5,87.5C 138.026,86.7628 133.359,84.4295 129.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e16629",
    d: "M 79.5,79.5 C 79.5,80.5 79.5,81.5 79.5,82.5C 76.7026,82.9666 75.3692,84.6333 75.5,87.5C 74.2883,89.9066 72.7883,92.24 71,94.5C 70.3292,95.2524 69.4959,95.5858 68.5,95.5C 69.031,92.763 69.8644,90.0964 71,87.5C 71.6667,88.8333 72.3333,88.8333 73,87.5C 73.6552,85.3716 74.4886,83.3716 75.5,81.5C 76.8333,80.8333 78.1667,80.1667 79.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e18d71",
    d: "M 151.5,93.5 C 153.179,93.2852 154.179,93.9519 154.5,95.5C 152.973,95.573 151.973,94.9063 151.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fde0c4",
    d: "M 75.5,87.5 C 75.8333,87.5 76.1667,87.5 76.5,87.5C 74.4888,91.0302 72.6554,94.6969 71,98.5C 69.2962,100.373 67.4628,102.04 65.5,103.5C 65.5569,102.391 65.8902,101.391 66.5,100.5C 67.1667,98.8333 67.8333,97.1667 68.5,95.5C 69.4959,95.5858 70.3292,95.2524 71,94.5C 72.7883,92.24 74.2883,89.9066 75.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaab8c",
    d: "M 154.5,95.5 C 156,97.2216 157.667,98.8883 159.5,100.5C 159.5,101.167 159.5,101.833 159.5,102.5C 156.677,101.008 155.01,98.6743 154.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d55022",
    d: "M 159.5,100.5 C 160.496,100.414 161.329,100.748 162,101.5C 163.591,103.927 164.425,106.593 164.5,109.5C 162.986,107.636 161.653,105.636 160.5,103.5C 159.833,103.5 159.5,103.167 159.5,102.5C 159.5,101.833 159.5,101.167 159.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6baa0",
    d: "M 160.5,103.5 C 161.653,105.636 162.986,107.636 164.5,109.5C 164.5,110.167 164.5,110.833 164.5,111.5C 161.593,109.685 160.259,107.019 160.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dc6a30",
    d: "M 66.5,100.5 C 65.8902,101.391 65.5569,102.391 65.5,103.5C 64.5987,104.29 63.9321,105.29 63.5,106.5C 61.7868,107.635 61.1201,109.302 61.5,111.5C 61.1667,111.5 60.8333,111.5 60.5,111.5C 59.9765,106.302 61.9765,102.635 66.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2a76e",
    d: "M 63.5,106.5 C 63.2041,108.403 62.5375,110.07 61.5,111.5C 61.1201,109.302 61.7868,107.635 63.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbedd9",
    d: "M 65.5,103.5 C 65.2505,109.593 63.2505,114.926 59.5,119.5C 59.8333,116.833 60.1667,114.167 60.5,111.5C 60.8333,111.5 61.1667,111.5 61.5,111.5C 62.5375,110.07 63.2041,108.403 63.5,106.5C 63.9321,105.29 64.5987,104.29 65.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da7748",
    d: "M 119.5,113.5 C 114.13,113.392 108.797,113.725 103.5,114.5C 108.664,111.02 113.997,110.686 119.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edaa88",
    d: "M 122.5,114.5 C 124.749,115.08 126.415,116.413 127.5,118.5C 125.251,117.92 123.585,116.587 122.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e39570",
    d: "M 164.5,111.5 C 166.277,114.505 167.277,117.838 167.5,121.5C 166.833,120.5 166.167,119.5 165.5,118.5C 165.007,116.194 164.674,113.861 164.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4b382",
    d: "M 103.5,114.5 C 100.599,117.312 97.9319,120.312 95.5,123.5C 96.1051,118.599 98.7718,115.599 103.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0491b",
    d: "M 164.5,109.5 C 164.833,109.5 165.167,109.5 165.5,109.5C 166.084,111.743 167.25,113.743 169,115.5C 169.167,120.167 169.333,124.833 169.5,129.5C 169.493,134.551 168.827,139.217 167.5,143.5C 167.5,136.167 167.5,128.833 167.5,121.5C 167.277,117.838 166.277,114.505 164.5,111.5C 164.5,110.833 164.5,110.167 164.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e38f58",
    d: "M 60.5,111.5 C 60.1667,114.167 59.8333,116.833 59.5,119.5C 58.3439,127.323 58.1772,135.323 59,143.5C 60.7068,145.909 61.5402,148.575 61.5,151.5C 60.8333,150.833 60.1667,150.167 59.5,149.5C 59.5386,148.244 59.0386,147.244 58,146.5C 57.1676,135.818 57.3343,125.151 58.5,114.5C 59.1757,113.398 59.8423,112.398 60.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb4503",
    d: "M 127.5,119.5 C 128.79,126.841 128.79,134.174 127.5,141.5C 127.5,142.167 127.5,142.833 127.5,143.5C 126.833,143.5 126.167,143.5 125.5,143.5C 120.826,145.171 116.16,146.838 111.5,148.5C 108.376,148.6 105.71,147.6 103.5,145.5C 104.919,141.007 105.919,136.341 106.5,131.5C 110.403,129.313 111.07,126.479 108.5,123C 108.765,120.849 109.765,119.182 111.5,118C 110.906,117.536 110.239,117.369 109.5,117.5C 109.389,116.883 109.056,116.383 108.5,116C 114.624,113.261 119.958,114.261 124.5,119C 125.448,119.483 126.448,119.649 127.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa5a04",
    d: "M 109.5,117.5 C 110.239,117.369 110.906,117.536 111.5,118C 109.765,119.182 108.765,120.849 108.5,123C 111.07,126.479 110.403,129.313 106.5,131.5C 105.919,136.341 104.919,141.007 103.5,145.5C 102.5,145.5 101.5,145.5 100.5,145.5C 100.103,142.554 99.1025,139.887 97.5,137.5C 97.335,134.15 97.5017,130.817 98,127.5C 99.7624,125.064 101.096,122.398 102,119.5C 102.689,118.643 103.522,117.977 104.5,117.5C 106.199,118.815 107.865,118.815 109.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eb6014",
    d: "M 119.5,113.5 C 120.609,113.557 121.609,113.89 122.5,114.5C 123.585,116.587 125.251,117.92 127.5,118.5C 127.5,118.833 127.5,119.167 127.5,119.5C 126.448,119.649 125.448,119.483 124.5,119C 119.958,114.261 114.624,113.261 108.5,116C 109.056,116.383 109.389,116.883 109.5,117.5C 107.865,118.815 106.199,118.815 104.5,117.5C 103.522,117.977 102.689,118.643 102,119.5C 101.096,122.398 99.7624,125.064 98,127.5C 97.5017,130.817 97.335,134.15 97.5,137.5C 96.8333,136.833 96.1667,136.167 95.5,135.5C 95.5,132.833 95.5,130.167 95.5,127.5C 95.5,126.167 95.5,124.833 95.5,123.5C 97.9319,120.312 100.599,117.312 103.5,114.5C 108.797,113.725 114.13,113.392 119.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d44322",
    d: "M 127.5,119.5 C 128.793,120.842 129.626,122.509 130,124.5C 130.499,128.821 130.666,133.154 130.5,137.5C 129.857,139.076 128.857,140.41 127.5,141.5C 128.79,134.174 128.79,126.841 127.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9e0cb",
    d: "M 165.5,118.5 C 166.167,119.5 166.833,120.5 167.5,121.5C 167.5,128.833 167.5,136.167 167.5,143.5C 167.167,143.5 166.833,143.5 166.5,143.5C 166.167,143.5 165.833,143.5 165.5,143.5C 166.751,135.17 166.751,126.837 165.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e57e45",
    d: "M 95.5,135.5 C 96.1667,136.167 96.8333,136.833 97.5,137.5C 99.1025,139.887 100.103,142.554 100.5,145.5C 97.1392,143.107 95.4726,139.773 95.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9bfa9",
    d: "M 130.5,137.5 C 130.975,140.313 129.975,142.313 127.5,143.5C 127.5,142.833 127.5,142.167 127.5,141.5C 128.857,140.41 129.857,139.076 130.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#de5922",
    d: "M 125.5,143.5 C 124.152,146.506 122.152,148.839 119.5,150.5C 118.167,150.5 116.833,150.5 115.5,150.5C 109.489,151.424 104.489,149.757 100.5,145.5C 101.5,145.5 102.5,145.5 103.5,145.5C 105.71,147.6 108.376,148.6 111.5,148.5C 116.16,146.838 120.826,145.171 125.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fceed5",
    d: "M 59.5,119.5 C 58.5304,130.019 59.8637,140.186 63.5,150C 67.0388,153.395 68.3722,157.562 67.5,162.5C 66.3634,161.211 65.0301,160.211 63.5,159.5C 63.8893,156.447 63.2227,153.78 61.5,151.5C 61.5402,148.575 60.7068,145.909 59,143.5C 58.1772,135.323 58.3439,127.323 59.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6c0a6",
    d: "M 125.5,143.5 C 126.167,143.5 126.833,143.5 127.5,143.5C 126.074,147.26 123.407,149.593 119.5,150.5C 122.152,148.839 124.152,146.506 125.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ed9273",
    d: "M 165.5,143.5 C 165.833,143.5 166.167,143.5 166.5,143.5C 166.706,146.495 166.04,149.162 164.5,151.5C 164.575,148.794 164.908,146.127 165.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f2e3",
    d: "M 95.5,127.5 C 95.5,130.167 95.5,132.833 95.5,135.5C 95.4726,139.773 97.1392,143.107 100.5,145.5C 104.489,149.757 109.489,151.424 115.5,150.5C 116.739,151.212 117.239,152.212 117,153.5C 115.262,154.127 113.429,154.46 111.5,154.5C 107.109,152.76 102.442,151.427 97.5,150.5C 97.8174,153.572 97.4841,156.572 96.5,159.5C 95.7687,150.945 94.7687,142.445 93.5,134C 93.5332,131.39 94.1999,129.223 95.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dc6c2b",
    d: "M 59.5,149.5 C 60.1667,150.167 60.8333,150.833 61.5,151.5C 63.2227,153.78 63.8893,156.447 63.5,159.5C 62.6285,157.437 61.4618,155.437 60,153.5C 59.51,152.207 59.3433,150.873 59.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#df7950",
    d: "M 164.5,151.5 C 164.5,152.833 164.5,154.167 164.5,155.5C 163.833,155.833 163.167,156.167 162.5,156.5C 162.12,154.302 162.787,152.635 164.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd4101",
    d: "M 166.5,143.5 C 166.833,143.5 167.167,143.5 167.5,143.5C 166.981,148.242 166.981,152.909 167.5,157.5C 172.629,158.614 172.629,159.281 167.5,159.5C 167.821,166.267 167.154,172.934 165.5,179.5C 166.167,182.167 166.833,184.833 167.5,187.5C 165.667,199.753 165,212.086 165.5,224.5C 160.833,224.5 156.167,224.5 151.5,224.5C 151.5,212.167 151.5,199.833 151.5,187.5C 152.5,187.5 153.5,187.5 154.5,187.5C 154.5,186.167 154.5,184.833 154.5,183.5C 151.167,183.5 147.833,183.5 144.5,183.5C 144.5,182.5 144.5,181.5 144.5,180.5C 145.978,180.762 147.311,180.429 148.5,179.5C 151.805,175.859 155.138,172.192 158.5,168.5C 159.429,167.311 159.762,165.978 159.5,164.5C 160.675,164.719 161.675,164.386 162.5,163.5C 163.295,160.856 163.962,158.189 164.5,155.5C 164.5,154.167 164.5,152.833 164.5,151.5C 166.04,149.162 166.706,146.495 166.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e16c2f",
    d: "M 68.5,164.5 C 69.9744,165.436 70.9744,166.77 71.5,168.5C 71.5,168.833 71.5,169.167 71.5,169.5C 68.9162,168.952 67.9162,167.285 68.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eda680",
    d: "M 71.5,169.5 C 71.5,169.167 71.5,168.833 71.5,168.5C 74.7642,170.094 77.4309,172.427 79.5,175.5C 76.5691,173.909 73.9024,171.909 71.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef9f81",
    d: "M 151.5,171.5 C 150.055,173.063 148.389,174.396 146.5,175.5C 147.129,173.003 148.796,171.67 151.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e85019",
    d: "M 164.5,155.5 C 163.962,158.189 163.295,160.856 162.5,163.5C 161.675,164.386 160.675,164.719 159.5,164.5C 159.762,165.978 159.429,167.311 158.5,168.5C 155.138,172.192 151.805,175.859 148.5,179.5C 147.311,180.429 145.978,180.762 144.5,180.5C 143.07,180.421 141.736,180.754 140.5,181.5C 139.672,185.743 137.339,187.076 133.5,185.5C 130.426,187.08 127.259,188.414 124,189.5C 120.943,188.549 117.777,188.216 114.5,188.5C 110.351,189.08 106.684,188.414 103.5,186.5C 110.175,186.666 116.842,186.5 123.5,186C 125.058,185.79 126.391,185.29 127.5,184.5C 128.833,184.167 130.167,183.833 131.5,183.5C 133.153,183.34 134.486,182.674 135.5,181.5C 135.842,180.662 136.508,180.328 137.5,180.5C 140.105,180.379 142.105,179.379 143.5,177.5C 143.821,175.952 144.821,175.285 146.5,175.5C 148.389,174.396 150.055,173.063 151.5,171.5C 154.937,166.274 158.604,161.274 162.5,156.5C 163.167,156.167 163.833,155.833 164.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd5303",
    d: "M 79.5,177.5 C 82.1524,181.11 85.8191,183.11 90.5,183.5C 91.8333,183.5 93.1667,183.5 94.5,183.5C 97.1445,185.242 100.145,185.909 103.5,185.5C 103.5,185.833 103.5,186.167 103.5,186.5C 106.684,188.414 110.351,189.08 114.5,188.5C 113.791,189.404 112.791,189.737 111.5,189.5C 111.5,201.167 111.5,212.833 111.5,224.5C 98.1667,224.5 84.8333,224.5 71.5,224.5C 71.6666,207.83 71.4999,191.163 71,174.5C 70.5,174 70,173.5 69.5,173C 70.825,173.148 71.9916,172.982 73,172.5C 74.02,173.891 74.8534,175.391 75.5,177C 76.7932,177.49 78.1266,177.657 79.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecb088",
    d: "M 79.5,175.5 C 82.1979,175.845 84.1979,177.178 85.5,179.5C 83.6854,178.37 81.6854,177.704 79.5,177.5C 79.5,176.833 79.5,176.167 79.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d96125",
    d: "M 79.5,177.5 C 81.6854,177.704 83.6854,178.37 85.5,179.5C 86.8333,180.167 88.1667,180.833 89.5,181.5C 89.8333,182.167 90.1667,182.833 90.5,183.5C 85.8191,183.11 82.1524,181.11 79.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eb9c79",
    d: "M 143.5,177.5 C 142.105,179.379 140.105,180.379 137.5,180.5C 138.911,178.461 140.911,177.461 143.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9b48b",
    d: "M 89.5,181.5 C 91.698,181.12 93.3646,181.787 94.5,183.5C 93.1667,183.5 91.8333,183.5 90.5,183.5C 90.1667,182.833 89.8333,182.167 89.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eea881",
    d: "M 135.5,181.5 C 134.486,182.674 133.153,183.34 131.5,183.5C 132.287,181.896 133.62,181.229 135.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe4702",
    d: "M 144.5,180.5 C 144.5,181.5 144.5,182.5 144.5,183.5C 147.833,183.5 151.167,183.5 154.5,183.5C 154.5,184.833 154.5,186.167 154.5,187.5C 153.5,187.5 152.5,187.5 151.5,187.5C 151.5,199.833 151.5,212.167 151.5,224.5C 138.167,224.5 124.833,224.5 111.5,224.5C 111.5,212.833 111.5,201.167 111.5,189.5C 112.791,189.737 113.791,189.404 114.5,188.5C 117.777,188.216 120.943,188.549 124,189.5C 127.259,188.414 130.426,187.08 133.5,185.5C 137.339,187.076 139.672,185.743 140.5,181.5C 141.736,180.754 143.07,180.421 144.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fac5a3",
    d: "M 127.5,184.5 C 126.391,185.29 125.058,185.79 123.5,186C 116.842,186.5 110.175,186.666 103.5,186.5C 103.5,186.167 103.5,185.833 103.5,185.5C 111.525,185.61 119.525,185.276 127.5,184.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiputan6New);
export default __webpack_public_path__ + "static/media/liputan6_new.02b984af636864722b9da6bc18590c9f.svg";
export { ForwardRef as ReactComponent };